import styled from 'styled-components';

const getAccessor = (col) => {
  switch (col) {
    default:
      return col.name;
  }
};

const getType = (col) => {
  switch (col.name) {
    case 'subject':
      return 'HTML';
    case 'receivedTime':
      console.log(col.name, 'i ran getType');
      return 'DateTime';
    default:
      return 'Text';
  }
};

const isEditable = (col) => {
  switch (col.name) {
    default:
      return false;
  }
};

const isFilterable = (col) => {
  switch (col.name) {
    default:
      return true;
  }
};

const isSortable = (col) => {
  switch (col.name) {
    default:
      return true;
  }
};

const getFields = (personalizedColumns) => {
  let fields = personalizedColumns;
  let fieldsToRequest = [
    {
      listInfo: ['page', 'pageSize', 'hasMore', 'totalCount']
    }
  ];
  let allFields = [];
  fields.forEach((el) => {
    switch (el.name) {
      case 'techGroup':
        allFields.push({
          techGroup: ['groupId', 'name']
        });
        break;
      case 'technician':
        allFields.push({
          technician: ['userId', 'email', 'firstName', 'lastName', 'name']
        });
        break;
      default:
        allFields.push(el.name);
    }
  });
  allFields = allFields.concat(['taskId', 'description']);
  fieldsToRequest.push({
    tasks: allFields
  });
  return fieldsToRequest;
};

const dependencyMap = {
  subcause: 'cause',
  subcategory: 'category',
  technician: 'techGroup'
};

const isDependantField = (field) => {
  return Object.keys(dependencyMap).indexOf(field) > -1;
};

const getParentField = (child) => {
  return dependencyMap[child];
};

const getDependantField = (parent) => {
  return Object.keys(dependencyMap).find(
    (key) => dependencyMap[key] === parent
  );
};

const DisabledTag = styled.div`
  opacity: 0.5;
`;
const CellWrapper = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .Polaris-Link {
    width: 100%;
  }
`;

const conditionMap = {
  3: {
    joinOperator: 'AND',
    operands: [
      {
        attribute: 'technician',
        operatorValue: 'placeholder.is.loggedin.user'
      }
    ]
  },
  4: {
    condition: {
      joinOperator: 'AND',
      operands: [
        {
          attribute: 'techGroup',
          operatorValue: 'placeholder.in.loggedin.techgroup'
        }
      ]
    }
  }
};

export {
  getAccessor,
  getType,
  isEditable,
  getFields,
  DisabledTag,
  dependencyMap,
  getDependantField,
  getParentField,
  isDependantField,
  CellWrapper,
  conditionMap,
  isSortable,
  isFilterable
};
